/**
 * Gets all values from an enum as string array
 * <p>a little bit generics would be nice</p>
 *
 * @param param an enum
 */
export function getValues( param: any ): string[] {
    let values: string[] = [];
    for ( const key of Object.keys( param ) ) {
        values.push( param[key] );
    }
    return values;
}
